import { render, staticRenderFns } from "./Hatch.vue?vue&type=template&id=06d9b68b&scoped=true"
import script from "./Hatch.vue?vue&type=script&lang=ts"
export * from "./Hatch.vue?vue&type=script&lang=ts"
import style0 from "./Hatch.vue?vue&type=style&index=0&id=06d9b68b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9b68b",
  null
  
)

export default component.exports